import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { toast } from "sonner";
import { useUser } from "#/hooks/use-user";
import DeleteAccountCard from "./DeleteAccountCard";
import { jsx as _jsx } from "react/jsx-runtime";
export function DeleteAccountView(t0) {
  const $ = _c(10);
  const {
    authClient,
    onSuccess,
    onBack
  } = t0;
  let t1;
  if ($[0] !== authClient) {
    t1 = {
      authClient
    };
    $[0] = authClient;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    deleteAccount,
    isUpdating
  } = useUser(t1);
  const [statusMessage, setStatusMessage] = useState(null);
  let t2;
  if ($[2] !== deleteAccount || $[3] !== onSuccess) {
    t2 = async () => {
      const response = await deleteAccount();
      if (response.success) {
        toast.success(response.message);
        if (onSuccess) {
          onSuccess();
        }
      } else {
        toast.error(response.message);
        setStatusMessage({
          message: response.message,
          variant: "error"
        });
      }
      return response;
    };
    $[2] = deleteAccount;
    $[3] = onSuccess;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleDelete = t2;
  let t3;
  if ($[5] !== handleDelete || $[6] !== isUpdating || $[7] !== onBack || $[8] !== statusMessage) {
    t3 = /*#__PURE__*/_jsx(DeleteAccountCard, {
      handleDelete: handleDelete,
      onBack: onBack,
      isLoading: isUpdating,
      statusMessage: statusMessage
    });
    $[5] = handleDelete;
    $[6] = isUpdating;
    $[7] = onBack;
    $[8] = statusMessage;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}